import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const HomeworkManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.8,
    marginTop: "4px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">
       

        {/* Grid Layout */}
        <div
          className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}
          style={{ alignItems: "stretch" }}
        >
          {/* Homework */}
          <Link to="/class-homework" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-pencil-alt"
                style={{ ...iconStyle, color: colors.primary }}
              ></i>
              <div>
                <h2 style={heading}>Homework</h2>
                <p style={subheading}>
                  View and manage homework details for the class.
                </p>
              </div>
            </div>
          </Link>

          {/* Assignments */}
          <Link to="/class-assignments" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-tasks"
                style={{ ...iconStyle, color: "#F97316" }}
              ></i>
              <div>
                <h2 style={heading}>Assignments</h2>
                <p style={subheading}>
                  Manage class assignments and deadlines.
                </p>
              </div>
            </div>
          </Link>

          {/* Course Material */}
          <Link to="/course-material" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-book-open"
                style={{ ...iconStyle, color: "#EAB308" }}
              ></i>
              <div>
                <h2 style={heading}>Course Material</h2>
                <p style={subheading}>
                  Access and upload course materials for students.
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeworkManagement;
